module.exports = __webpack_public_path__ + "static/media/tracis_horiz_color_large.cd015857.png";